import {LABELS} from '../../../../../shared/labels/Labels';
import {XeroSignupAction} from '../../../../actions';
import {NegativeMarginWrapper} from './styled';
import Banner from '@planday-corp/ui/indicators/Banner';
import Text from '@planday-corp/ui/text/Text';
import React, {useEffect, useState} from 'react';

interface RedirectCountdownBannerProps {
  handleRedirect: () => XeroSignupAction;
}

const COUNTDOWN_TIME_SECONDS = 30;

export default function RedirectCountdownBanner({
  handleRedirect,
}: RedirectCountdownBannerProps) {
  const [secondsToRedirect, setSecondsToRedirect] = useState(
    COUNTDOWN_TIME_SECONDS
  );

  useEffect(() => {
    if (secondsToRedirect === 0) {
      handleRedirect();
      return;
    }
    const intervalId = setInterval(() => {
      setSecondsToRedirect(secondsToRedirect - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [secondsToRedirect]);

  return (
    <NegativeMarginWrapper>
      <Banner type="warning" isSticky iconName="clock">
        <Text
          value={{
            ...LABELS.onboardingAutoRedirectCountdown,
            params: [secondsToRedirect],
          }}
        />
      </Banner>
    </NegativeMarginWrapper>
  );
}
